import { render, staticRenderFns } from "./ItemsStatus.vue?vue&type=template&id=0b9f4df1&scoped=true&"
import script from "./ItemsStatus.vue?vue&type=script&lang=js&"
export * from "./ItemsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ItemsStatus.vue?vue&type=style&index=0&id=0b9f4df1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f4df1",
  null
  
)

export default component.exports